<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-select v-model="args['storer.id']" :placeholder="$t('placeholder.storer')" allowClear style="width: 200px">
        <a-select-option v-for="d in storers" :key="d.id">{{ d.name }}</a-select-option>
      </a-select>
      <a-input-search v-model="args['no']" :placeholder="$t('placeholder.orderNo')" @pressEnter="search" @search="search"/>
      <a-input-search v-model="args['item.no']" :placeholder="$t('placeholder.itemNo')" @pressEnter="search" @search="search"/>
      <a-input-search v-model="args['item.name']" :placeholder="$t('placeholder.itemName')" @pressEnter="search" @search="search"/>
      <a-input-search v-model="args['item.barcodes']" :placeholder="$t('placeholder.itemBarcode')" @pressEnter="search" @search="search"/>
      <a-input-search v-model="args['lot.no']" :placeholder="$t('placeholder.lotNo')" @pressEnter="search" @search="search"/>
      <a-date-picker v-model="args.dateFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('placeholder.startTime')" show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="args.dateFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('placeholder.endTime')" show-today valueFormat="YYYY-MM-DD"/>
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="search"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
      <vxe-button content="button.expConfirm" size="mini" status="info" @click="exportExcel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :height="scrollY"
      size="mini"
      :scroll-x="{enabled: true}"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="order.no" sortable title="business.label.orderNo" width="120"/>
      <vxe-column field="order.invoiceTime" sortable title="business.label.invoiceTime" width="170"/>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="150"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="150"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="dosageForm.name" title="business.label.dosageForm" width="120"/>
      <vxe-column field="item.permitHolder" title="business.label.permitHolder" width="140"/>
      <vxe-column field="lot.no" sortable title="business.label.lotNo" width="100"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
      <vxe-column field="lot.producingArea" title="business.label.producingArea" width="150"/>
      <vxe-column field="submissionAdvice.operator" title="business.label.submissionAdviceOperator" width="150"/>
      <vxe-column field="submissionAdvice.content" title="business.label.submissionAdviceContent" width="150"/>
      <vxe-column field="approvalAdvice.operator" title="business.label.approvalAdviceOperator" width="150"/>
      <vxe-column field="approvalAdvice.content" title="business.label.approvalAdviceContent" width="150"/>
      <vxe-column field="reportAdvice.operator" title="business.label.reportAdviceOperator" width="150"/>
      <vxe-column field="reportAdvice.content" title="business.label.reportAdviceContent" width="150"/>
      <vxe-column field="destructionAdvice.operator" title="business.label.destructionAdviceOperator" width="150"/>
      <vxe-column field="destructionAdvice.content" title="business.label.destructionAdviceContent" width="150"/>
      <vxe-column field="detail.quantity" title="business.label.quantity" width="120"/>
      <vxe-column field="detail.reasons" title="business.label.reason" width="120"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll } from '@/api/Api'
import moment from 'moment'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'ReceiptDetailQuery',
    data() {
      return {
        data: [],
        storers: [],
        loading: false,
        size: 15,
        page: 1,
        contentSize: 0,
        args: {
          'no': '',
          'storer.id': null,
          dateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          },
          'item.no': '',
          'item.name': '',
          'item.barcodes': '',
          'lot.no': ''
        },
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.8125)// 表格竖向滚动条
      }
    },
    mounted() {
      findAll('storerFactory', {available: true}).then(res => {
        if (res.success) {
          this.storers = res.result
        }
      })
    },
    methods: {
      moment,
      disabledStartDate(startValue) {
        const endValue = this.args.dateFilter.end
        if (!startValue || !endValue) {
          return false
        }
        return new Date(startValue) > new Date(endValue)
      },
      disabledEndDate(endValue) {
        const startValue = this.args.dateFilter.start
        if (!endValue || !startValue) {
          return false
        }
        return new Date(startValue) >= new Date(endValue)
      },
      pageChange({currentPage, pageSize}) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      getData() {
        this.loading = true
        findAll('disqualificationDetailFactory', this.args, this.page, this.size).then(res => {
          if (res.success) {
            this.data = res.result
            this.contentSize = res.contentSize
          }
        }).finally(() => this.loading = false)
      },
      search() {
        this.page = 1
        this.getData()
      },
      exportExcel() {
        this.$refs.table.openExport()
      },
      reset() {
        this.args = {
          'no': '',
          'storer.id': undefined,
          dateFilter: {
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
          },
          'item.no': '',
          'item.name': '',
          'item.barcodes': '',
          'lot.no': ''
        }
        this.getData()
      }
    }
  }
</script>